<template>
  <ankh-list :showSearchForm="false">
    <template #btn-group>
      <el-button icon="el-icon-delete" @click.native="$refs.table.handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #tab-row>
      <el-radio-group v-model="current" class="mb16">
        <el-radio-button label="dynamics">{{$t('动态举报')}}</el-radio-button>
        <el-radio-button label="comment">{{$t('评论举报')}}</el-radio-button>
        <el-radio-button label="cookbook">{{$t('菜谱举报')}}</el-radio-button>
        <el-radio-button label="account">{{$t('账号举报')}}</el-radio-button>
      </el-radio-group>
    </template>
    <template #table="{height}">
      <report-table
          :height="height"
          ref="table"
          :list="tableOptionList"
          :current-flag="current"  />

    </template>
  </ankh-list>
</template>

<script>
import ReportTable from "@/components/report/ReportTable";
import AnkhList from "@/components/list/AnkhList.vue";

const tabs = {
  dynamics: [
    {position: "p1", label: "被举报动态编号", type: "text", prop: "dynamicsNum"},
    {position: "p2", label: "被举报动态内容", type: "text", prop: "dynamicsContent"}
  ],
  comment: [
    {position: "p1", label: "被举报评论编号", type: "text", prop: "commentNum"},
    {position: "p2", label: "被举报评论内容", type: "text", prop: "commentContent"}
  ],
  cookbook: [
    {position: "p1", label: "被举报菜谱编号", type: "text", prop: "cookbookNum"},
    {position: "p2", label: "图片", type: "img", prop: "cookbookPhoto"},
    {position: "p2", label: "被举报菜谱名称", type: "text", prop: "cookbookName"}
  ],
  account: [
    {position: "p2", label: "头像", type: "img", prop: "beReportUserPortrait"},
  ]
}

export default {
  name: "ReportList",
  components: {AnkhList, ReportTable},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      current: "dynamics",
    }
  },
  methods: {
    // 审核
    handleAudit() {

    },

  },
  computed: {
    tableOptionList() {
      return tabs[this.current];
    }
  }
}
</script>

<style scoped>

</style>
